import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PatientPageComponent } from './patient.component';
import { AuthGuard } from '../guards/auth.guard';
import { MatButtonModule} from '@angular/material/button';
import { HelpTooltipModule } from '../components/helpTooltip/helpTooltip.module';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { ListingModule } from '../components/listing/listing.module';
import { VarModule } from '../directives/ngVar';
import { DateSelectDialogModule } from '../components/date-select-dialog/date-select-dialog.module';
import { ListSearchSelectDialogModule } from '../components/list-search-select-dialog/list-search-select-dialog.module';
import { TrackingAnalysisModule } from './tracking-analysis/tracking-analysis.module';
import { MatIconModule } from '@angular/material/icon';
import { TreatmentsModule } from './treatments/treatments.module';
import { CompassTabModule } from '../components/compass-tab/compass-tab.module';
import { DocumentsModule } from '../components/documents/documents.module';
import { RemindersModule } from './reminders/reminders.module';
import { TimelineModule } from '../components/timeline/timeline.module';
import { PatientTagComponentModule } from '../components/patient-tags/patient-tags.module';

@NgModule({
  imports: [
    CommonModule,
    CompassTabModule,
    DocumentsModule,
    FormsModule,
    MatButtonModule,
    HelpTooltipModule,
    TimelineModule,
    VarModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ListingModule,
    MatSelectModule,
    PatientTagComponentModule,
    RemindersModule,
    TrackingAnalysisModule,
    TreatmentsModule,
    RouterModule.forChild([
      {
        path: 'patient/:patientId',
        canActivate: [AuthGuard],
        component: PatientPageComponent,
        children: []
      }
    ])
  ],
  declarations: [
    PatientPageComponent
  ],
  exports: [
    PatientPageComponent
  ],
  providers: [
    DateSelectDialogModule,
    ListSearchSelectDialogModule
  ]
})
export class PatientModule{}
